import React from 'react'
import GamaCromatica from './gama-cromatica/gama-cromatica'
import Tipografia from './tipografia/tipografia'
import Botones from './botones/botones'
import Formularios from './formularios/formularios'
import Tablas from './tablas/tablas'
import Alertas from './alertas/alertas'
import PopUps from './pop-ups/pop-ups'
import Graficas from './graficas/graficas'

const GuiaDeEstilos = () => {
  return (
    <>
      <GamaCromatica />
      <Tipografia />
      <Botones />
      <Formularios />
      <Tablas/>
      <Alertas />
      <PopUps />
      <Graficas />
    </>
  )
}

export default GuiaDeEstilos